<template>
  <div class="iconbox">
    <div class="iconbox-container">
      <div class="icon-container">
        <template v-if="avatarSrc">
          <img
            :src="avatarSrc"
            class="iconbox-iconimg"
            alt="avatar"
            :srcset="avatarSrcset"
          />
        </template>
        <div v-else-if="iconName" class="iconbox-icon">
          <dotcom-icon
            class="icon"
            :name="iconName"
            color="--c-primary-neutral-1"
          />
        </div>
      </div>

      <div class="iconbox-content">
        <h2 v-if="$slots.title" class="iconbox-title">
          <slot name="title"></slot>
        </h2>
        <h4 v-if="$slots.abstract" class="iconbox-abstract">
          <slot name="abstract"></slot>
        </h4>
        <p v-if="$slots.content" class="center">
          <slot name="content"></slot>
        </p>
        <p v-if="$slots.contentpar">
          <slot name="contentpar"></slot>
        </p>
        <a
          v-if="linkUrl"
          target="_blank"
          class="center iconbox-link"
          :href="linkUrl"
        >
          <slot name="urlTitle"></slot>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SanitasMagazineIconBox',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    avatarSrc: {
      type: String,
      default: '',
    },
    avatarSrcset: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: 'fal-user',
    },
    linkUrl: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="postcss">
.iconbox {
  li {
    line-height: 1.5em;
  }

  &-content {
    margin-top: 80px;
  }

  .iconbox {
    &-container {
      ol {
        padding-left: 23px;
      }
    }
  }

  &-container {
    border: 1px solid var(--c-primary-neutral-1);
    margin-bottom: 40px;
    margin-top: 80px;
    padding: 0 6.75%;
    position: relative;
    overflow-wrap: break-word;

    &:before {
      content: '';
      display: block;
      margin: -3px auto;
      width: 160px;
      border-bottom: 6px solid var(--c-primary-neutral-3);
    }

    & + .iconbox {
      margin-top: 130px;
    }

    img.iconbox-iconimg {
      width: 100px;
      height: 100px;
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid var(--c-primary-neutral-1);
      margin: 0 auto -20px;
      display: block;
      position: relative;
      object-fit: cover;
    }

    &.iconbox-container.iconbox-container p {
      /* wrapper has Faustina font-family ! */
      font-family: 'Open Sans', sans-serif;
    }

    h2.iconbox-title {
      font-size: 36px;
      font-weight: 700;
      color: var(--c-primary-neutral-1);
      text-align: center;
      margin-bottom: 40px;
    }

    @media (max-width: 490px) {
      h2.iconbox-title {
        font-size: 24px;
      }
    }

    h4.iconbox-abstract {
      font-size: 20px;
      font-weight: 700;
      color: var(--c-primary-neutral-1);
      text-align: center;
      margin-bottom: 10px;
    }

    p.lead {
      font-size: 20px;
      line-height: 1.5;
      font-weight: 700;
      text-align: center;
    }

    a {
      color: var(--c-primary-color-3);

      &.iconbox-link {
        font-size: 20px;
        line-height: 20px;
        display: block;
        margin-bottom: 40px;
        font-weight: bold;
        text-decoration: underline;
      }

      &:hover {
        color: var(--c-primary-color-3);
      }
    }

    .san-richtext {
      sup {
        top: -0.2em !important;
      }
    }

    .center {
      text-align: center;
    }

    .icon-container {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: -50px;
      width: 100%;
      left: 0;

      .iconbox-icon {
        width: 100px;
        height: 100px;
        border: 1px solid var(--c-primary-neutral-1);
        border-radius: 50%;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .dotcom-icon {
          cursor: initial;
          font-size: 64px;
        }
      }
    }
  }
}

@media (max-width: 490px) {
  .iconbox {
    .iconbox {
      &-container {
        ol {
          padding-left: 17px;
        }
      }
    }
  }
}
</style>
